import React from 'react';
import { ActionsMenu } from '../AccountsUsers/ActionsMenu';
import { REQUIRED_FIELD_LABELS } from './constants';

const CONTENT_LABELS = { ebook: 'Ebook', audiobook: 'Audiolibro', pod: 'POD' };

export function ChannelsTable({ channels, onEdit, onToggleActive, onDelete }) {
    return (
        <div className="modern-table-container">
            <table className="modern-table striped-table">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Alias</th>
                        <th>Estado</th>
                        <th>Contenido</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {channels.map((ch) => {
                        const isComplete = ch.is_complete === true;
                        const missingLabels = (ch.missing_fields || []).map((field) => REQUIRED_FIELD_LABELS[field] || field);
                        const missingText = missingLabels.length > 0 ? missingLabels.join(', ') : 'Campos obligatorios';
                        const statusTitle = isComplete ? 'Campos completos' : `Faltan: ${missingText}`;
                        const activateDisabled = !ch.active && !isComplete;
                        const items = [
                            {
                                label: isComplete ? 'Ver / Editar' : 'Completar configuración',
                                onClick: () => onEdit(ch),
                            },
                            {
                                label: ch.active ? 'Desactivar' : 'Activar',
                                onClick: () => onToggleActive(ch),
                                disabled: activateDisabled,
                                title: activateDisabled ? 'Completa la configuración del canal para poder activarlo' : undefined,
                            },
                            { label: 'Eliminar', danger: true, onClick: () => onDelete(ch) },
                        ];
                        return (
                            <tr key={ch._id}>
                                <td className="short fw-bold text-white">{ch.name}</td>
                                <td className="short text-white-50">{ch.alias}</td>
                                <td className="short">
                                    <div className="d-flex flex-column align-items-start gap-1" title={statusTitle}>
                                        <span className={`badge-status ${isComplete ? (ch.active ? 'status-on' : 'status-off') : 'status-warning'}`}>
                                            {isComplete ? (ch.active ? 'Activo' : 'Inactivo') : 'Incompleto'}
                                        </span>
                                        <small className="text-white-50">
                                            {isComplete ? 'Campos completos' : `Faltan: ${missingText}`}
                                        </small>
                                    </div>
                                </td>
                                <td className="short">
                                    {(ch.content || []).map((c) => (
                                        <span key={c} className="badge-status status-disabled me-1">{CONTENT_LABELS[c] || c}</span>
                                    ))}
                                    {(!ch.content || ch.content.length === 0) && <span className="text-white-50">—</span>}
                                </td>
                                <td>
                                    <ActionsMenu items={items} title="Acciones del canal" />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default ChannelsTable;
